import React from "react";
import { useNavigate } from "react-router-dom";
import { Lightbulb, Wrench, Rocket, Trophy, Crown, CalendarDays } from "lucide-react";

// §13 — the weekly community rhythm, connecting existing surfaces into one calendar.
const EVENTS = [
  { day: 1, icon: Lightbulb, title: "Prompt Challenge", tag: "Mon", desc: "A fresh theme to build from.", grad: "from-amber-400 to-orange-500", to: "/app/challenges" },
  { day: 3, icon: Wrench, title: "Build Workshop", tag: "Wed", desc: "Level up your creation skills.", grad: "from-[#3b9eff] to-[#1f6feb]", to: "/app/create" },
  { day: 5, icon: Rocket, title: "Fresh Launches", tag: "Fri", desc: "New games hit the Arcade.", grad: "from-emerald-400 to-teal-500", to: "/app/discover" },
  { day: 6, icon: Trophy, title: "Weekend Tournament", tag: "Sat", desc: "Climb the momentum race.", grad: "from-fuchsia-500 to-purple-600", to: "/app/creator-race" },
  { day: 0, icon: Crown, title: "Creator Awards", tag: "Sun", desc: "Creator of the Week crowned.", grad: "from-yellow-400 to-amber-500", to: "/app/creator-race" },
];

export default function WeeklyEventsStrip() {
  const navigate = useNavigate();
  const today = new Date().getDay(); // 0=Sun..6=Sat

  const isActive = (e) => {
    if (e.title === "Weekend Tournament") return today === 6 || today === 0;
    return e.day === today;
  };

  return (
    <div className="mb-9" data-testid="weekly-events-strip">
      <div className="flex items-center gap-2 mb-3">
        <CalendarDays className="w-5 h-5 text-[hsl(var(--primary))]" />
        <h2 className="font-display text-xl font-extrabold">This week on GameView</h2>
        <span className="text-xs text-[hsl(var(--muted-foreground))] hidden sm:inline">— a new reason to create every day</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {EVENTS.map((e) => {
          const active = isActive(e);
          const Icon = e.icon;
          return (
            <button key={e.title} onClick={() => navigate(e.to)} data-testid={`week-event-${e.tag.toLowerCase()}`}
              className={`relative text-left rounded-2xl border p-3.5 transition-all card-hover ${
                active ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))]/[0.07] ring-1 ring-[hsl(var(--primary))]/30"
                       : "border-[hsl(var(--border))] bg-[hsl(var(--card))]"}`}>
              {active && (
                <span data-testid="week-event-today"
                  className="absolute top-2 right-2 text-[9px] font-extrabold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-[hsl(var(--primary))] text-white">
                  Today
                </span>
              )}
              <div className={`w-9 h-9 rounded-xl grid place-items-center bg-gradient-to-br ${e.grad} mb-2`}>
                <Icon className="w-4 h-4 text-white" strokeWidth={2.4} />
              </div>
              <div className="text-[10px] font-bold uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{e.tag}</div>
              <div className="font-display font-bold text-sm leading-tight">{e.title}</div>
              <div className="text-[11px] text-[hsl(var(--muted-foreground))] mt-0.5 leading-snug">{e.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
